__turbopack_context__.v({
  "ctaBand": "canm-module__LTKoYW__ctaBand",
  "ctaBandSlim": "canm-module__LTKoYW__ctaBandSlim",
  "ctaHeadline": "canm-module__LTKoYW__ctaHeadline",
  "ctaSubtitle": "canm-module__LTKoYW__ctaSubtitle",
  "hairline": "canm-module__LTKoYW__hairline",
  "hero": "canm-module__LTKoYW__hero",
  "heroKicker": "canm-module__LTKoYW__heroKicker",
  "heroTagline": "canm-module__LTKoYW__heroTagline",
  "heroTitle": "canm-module__LTKoYW__heroTitle",
  "kicker": "canm-module__LTKoYW__kicker",
  "lede": "canm-module__LTKoYW__lede",
  "numberFigure": "canm-module__LTKoYW__numberFigure",
  "numberedItem": "canm-module__LTKoYW__numberedItem",
  "numberedItemText": "canm-module__LTKoYW__numberedItemText",
  "numberedList": "canm-module__LTKoYW__numberedList",
  "sectionTitle": "canm-module__LTKoYW__sectionTitle",
  "serif": "canm-module__LTKoYW__serif",
});
